import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '../../helpers/api-helper';
import CompanyApi from '../../../infrastructure/company-api';
export const createCompanyAsync = createAsyncThunk('company/create', async (company, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CompanyApi.createCompany(company);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getCompaniesAsync = createAsyncThunk('company/getAll', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CompanyApi.getCompanies();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteCompanyAsync = createAsyncThunk('company/delete', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CompanyApi.deleteCompany(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const toggleCompanyActivationAsync = createAsyncThunk('company/toggleActivation', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CompanyApi.toggleCompanyActivation(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateCompanyAsync = createAsyncThunk('company/update', async (company, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CompanyApi.updateCompany(company);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
